import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/collections/redux/actions';
import * as homeActions from '../../features/home/redux/actions';
import * as commonActions from '../../features/common/redux/actions';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { drapcodeIcon } from '../../common/custom/icon-library';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import { RestApiDataDisplay } from './RestApiDataDisplay';
import { showAlertHtml } from '../../common/utils/alert';
import CustomLoader from '../common/CustomLoader';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/ext-language_tools';

export class CollectionWithRestApi extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };
  state = {
    collectionName: '',
    url: '',
    methodType: 'get',
    restApidata: '',
    header: [{ key: '', value: '' }],
    responseData: '',
    jsonConfig: {},
    dataItem: '',
    isPersistent: true,
    bodyJSON: '',
    urlError: '',
  };

  setCollectionName = (value) => {
    this.setState({ collectionName: value });
  };
  handleChange = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  };
  updateJsonConfig = (value) => {
    this.setState({ jsonConfig: value });
  };
  handleSendRequset = async () => {
    const { methodType, url, header } = this.state;
    if (!url) {
      this.setState({ urlError: 'This field is required' });
    }
    if (url) {
      this.setState({ urlError: '' });
      const { actions } = this.props;
      if (methodType === `get`) {
        const headers = {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        };
        header.forEach((pair) => {
          if (pair.key && pair.value) {
            headers[pair.key] = pair.value;
          }
        });
        actions.responceForRestApi({ methodType, headers, url });
      } else {
        const { header, url, bodyJSON, methodType } = this.state;
        const { actions } = this.props;
        const headers = {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        };
        header.forEach((pair) => {
          if (pair.key && pair.value) {
            headers[pair.key] = pair.value;
          }
        });
        const body = bodyJSON ? JSON.parse(bodyJSON) : null;
        actions.responceForRestApi({ methodType, url, body, headers });
      }
      actions.isOpenCollectionCreateWithRestApi();
    }
  };
  handleFormSubmit = async (values) => {
    const { projectId, version } = this.props;
    const { collectionName, isPersistent, jsonConfig } = this.state;
    const data = {
      collectionTitle: collectionName,
      willPersist: isPersistent,
      fields: jsonConfig,
      projectId,
      version,
    };
    const { actions, homeActions, commonActions } = this.props;
    const createCollectionResponse = await actions.createCollectionWithCsv(data);
    await actions.loadProjectCollections({ projectId, version });
    if (createCollectionResponse && createCollectionResponse.data.uuid) {
      commonActions.trackCollectionChange({
        uuid: createCollectionResponse.data.uuid,
        name: createCollectionResponse.data.collectionName,
      });
      homeActions.loadEditorCollections({ projectId, version });
      const collectionId = createCollectionResponse.data.uuid;
      actions.loadProjectCollectionDetail({ projectId, collectionId });
      if (this.props.home && this.props.home.collections.length === 0) {
        this.props.projectOnBoardActions.changeProjectStatus({
          state: 'COLLECTION_CREATED',
          status: 'COMPLETE',
          projectId,
          version,
        });
      }
      const redirectPath = `/2.0/collections/${version}/v/${projectId}/edit/${collectionId}`;
      this.props.history.push(redirectPath);
      actions.isOpenCollectionCreateWithRestApi();
      return;
    }
  };
  handleChangekeyValue = (index, field, value) => {
    const header = [...this.state.header];
    header[index][field] = value;
    if (index === header.length - 1 && (header[index].key || header[index].value)) {
      header.push({ key: '', value: '' });
    }
    this.setState({ header });
  };
  setCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (name === 'willPersist') {
      const confirmationMsg = checked
        ? `The DrapCode (default) database will be used to store and retrieve data.<br/><br/>Do you want to proceed?`
        : `Data will be fetched from an external source.<br/>Hence, you will <strong>not</strong> be able to store item data in the DrapCode (default) database.<br/><br/>Do you want to proceed?`;

      if (checked) {
        const preConfirm = () => {
          this.setState({ isPersistent: checked });
        };
        showAlertHtml(confirmationMsg, preConfirm, 'Proceed');
      } else {
        const preConfirm = () => {
          this.setState({ isPersistent: checked });
        };
        showAlertHtml(confirmationMsg, preConfirm, 'Proceed');
      }
    } else {
      this.setState({ [name]: checked });
    }
  };
  render() {
    const { collections, actions } = this.props;
    const { isPersistent, collectionName, urlError, dataItem } = this.state;
    const { responseData } = this.props.collections;
    const typeDescription = `<ul style="padding-left:1rem"><li><strong>Persistent collection</strong> when <em>ON</em> will store item data in <em>DrapCode (default) database</em>.</li><li><strong>Persistent collection</strong> when <em>OFF</em> will not store any item data in <em>DrapCode (default) database</em>.</li></ul>`;
    return (
      <>
        <div className="card">
          <div className="card-header card-header-icon" data-background-color="drapcode-dark-blue">
            <i className={`wb ${drapcodeIcon('collection')}`}></i>
          </div>
          <div className="card-content">
            <div className="card-title-header">
              <h4 className="card-title">
                Create Collection <span style={{ textTransform: 'none' }}>via</span> REST API
              </h4>
              <div className="card-cta"></div>
            </div>
            <div className="row">
              <div className="col-sm-2">
                <CustomInputWithIcon icon="select" title="Select Request Type">
                  <select
                    name="methodType"
                    onChange={this.handleChange}
                    value={this.state.methodType}
                    className="form-control form-control-sm custom-select-sm"
                  >
                    <option value="get">GET</option>
                    <option value="post">POST</option>
                  </select>
                </CustomInputWithIcon>
              </div>
              <div className="col-sm-10">
                <CustomInputWithIcon icon="url" title="URL">
                  <input
                    id="url"
                    name="url"
                    type="text"
                    className="form-control form-control-sm"
                    onChange={this.handleChange}
                    value={this.state.url}
                    placeholder="REST API URL"
                  />
                  {urlError && <p className="text-danger">{urlError}</p>}
                </CustomInputWithIcon>
              </div>
            </div>
            <div className="card">
              <h4>
                <b className="ml-4">Headers</b>
              </h4>
              <div className="row pt-2">
                <div className="col-md-4 col-lg-4">
                  <label className="ml-4">Key</label>
                </div>
                <div className="col-md-8 col-lg-8">
                  <label className="ml-4">Value</label>
                </div>
              </div>
              <div className="pb-4">
                {this.state.header.map((pair, index) => (
                  <div className="row pt-2" key={index}>
                    <div className="col-md-4 col-lg-4 ml-4 ">
                      <input
                        name="key"
                        type="text"
                        placeholder="key"
                        className="form-control form-control-sm"
                        onChange={(e) => this.handleChangekeyValue(index, 'key', e.target.value)}
                        value={pair.key}
                      />
                    </div>
                    <div className="col-md-7 col-lg-7 ">
                      <div>
                        <input
                          name="value"
                          type="text"
                          placeholder="Value"
                          className="form-control form-control-sm"
                          onChange={(e) =>
                            this.handleChangekeyValue(index, 'value', e.target.value)
                          }
                          value={pair.value}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className=" col-sm-12">
              <CustomInputWithIcon icon="text">
                <input
                  name="itemsPath"
                  onChange={(e) => this.setState({ dataItem: e.target.value })}
                  value={dataItem}
                  className="form-control form-control-sm"
                  placeholder="Response Data Items Path (Optional)"
                />
              </CustomInputWithIcon>
            </div>
            {this.state.methodType === `post` && (
              <div className="mx-auto">
                <div className="form-group">
                  <div className="card">
                    <div className="m-3">
                      <h4>
                        <b> Request Body JSON</b>
                      </h4>
                    </div>
                    <AceEditor
                      height="250px"
                      width="100%"
                      mode="json"
                      theme="github"
                      value={this.state.bodyJSON}
                      onChange={(e) => this.setState({ bodyJSON: e })}
                      showPrintMargin={false}
                      setOptions={{
                        enableBasicAutocompletion: true,
                        enableLiveAutocompletion: true,
                        enableAutoIndent: true,
                        enableSnippets: true,
                      }}
                      editorProps={{ $blockScrolling: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="text-right ml-3">
              <button
                className="btn btn-theme-submit mt-3"
                onClick={this.handleSendRequset}
                disabled={collections.responceForRestApiPending}
              >
                <i className="wb webconnect-rocket"></i>
                &nbsp;Send Request&nbsp;
                <CustomLoader loading={collections.responceForRestApiPending}></CustomLoader>
              </button>
            </div>
          </div>
        </div>
        {responseData && (
          <Modal
            isOpen={collections.isOpenCollectionCreateWithRestApi}
            toggle={() => {
              actions.isOpenCollectionCreateWithRestApi();
            }}
            backdrop="static"
            style={{ maxWidth: '40%', marginTop: '70px' }}
          >
            <ModalHeader
              toggle={() => {
                actions.isOpenCollectionCreateWithRestApi();
              }}
              className="border-bottom"
            >
              <strong>Create Collection via REST API</strong>
            </ModalHeader>
            <ModalBody>
              <RestApiDataDisplay
                setCollectionName={this.setCollectionName}
                collectionName={collectionName}
                responseData={responseData}
                actions={this.props.actions}
                updateJsonConfig={this.updateJsonConfig}
                onSubmitForm={this.handleFormSubmit}
                isPersistent={isPersistent}
                setCheckboxChange={this.setCheckboxChange}
                typeDescription={typeDescription}
                collections={this.props.collections}
                optionalPath={dataItem}
              ></RestApiDataDisplay>
            </ModalBody>
          </Modal>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    homeActions: bindActionCreators({ ...homeActions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionWithRestApi);
